import ClaimNameFatFingerModal from './ClaimNameFatFingerModal.container'
export default ClaimNameFatFingerModal
